import { render, staticRenderFns } from "./GalleryCategory.vue?vue&type=template&id=db04b86c&scoped=true&"
import script from "./GalleryCategory.vue?vue&type=script&lang=js&"
export * from "./GalleryCategory.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCategory.vue?vue&type=style&index=0&id=db04b86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db04b86c",
  null
  
)

export default component.exports